import toast from 'react-hot-toast';
import useApi from '../useApi';
import { INoteReq, IPatientRes } from './index.type';

const useAddNote = ({ patientId }: { patientId?: string }) => {
  const { loading: addNoteLoading, makeApiCall } = useApi({ url: `/rtm/note?patientId=${patientId}`, method: 'POST' });

  const addNote = async (formData: INoteReq) => {
    const { response, error } = await makeApiCall<INoteReq, IPatientRes>(formData);
    if (response?.status === 'success') {
      toast.success('Note added successfully');
      return response;
    }

    if (error || !response?.status) {
      toast.error(error?.msg || 'Failed to save note. Please check note content and try again.');
      return { status: 'fail' };
    }
  };

  return {
    addNoteLoading,
    addNote,
  };
};

export default useAddNote;
